/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidencePaymentWithEvidenceWarnings
 */
export interface EvidencePaymentWithEvidenceWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'detectedDpi'?: EvidencePaymentWithEvidenceWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'calculatedDpi'?: EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'colorGradation'?: EvidencePaymentWithEvidenceWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'heightMillis'?: EvidencePaymentWithEvidenceWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'widthMillis'?: EvidencePaymentWithEvidenceWarningsWidthMillisEnum;
}

export const EvidencePaymentWithEvidenceWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceWarningsDetectedDpiEnum = typeof EvidencePaymentWithEvidenceWarningsDetectedDpiEnum[keyof typeof EvidencePaymentWithEvidenceWarningsDetectedDpiEnum];
export const EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum = typeof EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum[keyof typeof EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum];
export const EvidencePaymentWithEvidenceWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidencePaymentWithEvidenceWarningsColorGradationEnum = typeof EvidencePaymentWithEvidenceWarningsColorGradationEnum[keyof typeof EvidencePaymentWithEvidenceWarningsColorGradationEnum];
export const EvidencePaymentWithEvidenceWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceWarningsHeightMillisEnum = typeof EvidencePaymentWithEvidenceWarningsHeightMillisEnum[keyof typeof EvidencePaymentWithEvidenceWarningsHeightMillisEnum];
export const EvidencePaymentWithEvidenceWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceWarningsWidthMillisEnum = typeof EvidencePaymentWithEvidenceWarningsWidthMillisEnum[keyof typeof EvidencePaymentWithEvidenceWarningsWidthMillisEnum];


